import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

// 通用功能路由组件
import Index from '@/components/Index';
import CommonResult from '@/components/common/CommonResult';

//搜索结果页路由组件
import ResultContainer from '@/components/results/ResultContainer';
import TextResults from '@/components/results/TextResults';
import ImageResults from '@/components/results/ImageResults.vue';
import VideoResults from '@/components/results/VideoResults.vue';
import AudioResultcs from '@/components/results/AudioResults.vue';

//个人中心页路由组件
import PersonalCenter from '@/components/personal/PersonalCenter';
import MyEvidences from '@/components/personal/MyEvidences';
import Trash from '@/components/personal/Trash';
import AccountInfo from '@/components/personal/AccountInfo';
import AccountBalance from '@/components/personal/AccountBalance';
import OnlinePayment from '@/components/personal/OnlinePayment';

//重置密码页面路由组件
import Reset from '@/components/user/Reset'
import Validate from '@/components/user/Validate'
import Confirm from '@/components/user/Confirm'
import ResetResult from '@/components/user/ResetResult'
import JumpMail from '@/components/user/JumpMail'

//意见反馈路由组件
import ParentFeedback from '@/components/others/ParentFeedback'
import FeedBack from '@/components/others/FeedBack'
import FeedbackSuccess from '@/components/others/Success'

//充值成功路由组件
import ChargeResult from '@/components/personal/ChargeResult'

Vue.use(Router);
let authPath = [
  'sc/addEvidence'
];

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/result',
      name: 'result',
      component: CommonResult,
    },
    {
      path: '/charge_result',
      component: ChargeResult
    },
    {
      path: '/feedback/',
      component: ParentFeedback,
      children: [
        {
          path: '/',
          component: FeedBack
        },
        {
          path: 'success',
          component: FeedbackSuccess
        },
        {
          path: 'childfeedback',
          component: FeedBack
        }
      ]
    },
    {
      path: '/reset/',
      component: Reset,
      children: [
        {
          path: '/',
          component: Validate
        },
        {
          path: 'validate',
          component: Validate
        },
        {
          path: 'confirm',
          component: Confirm
        },
        {
          path: 'resetresult',
          component: ResetResult
        },
        {
          path: 'JumpMail',
          component: JumpMail
        }
      ]
    },
    {
      path: '/results/',
      name: 'ResultContainer',
      component: ResultContainer,
      children: [
        {
          path: '/',
          component: TextResults
        },{
          path: 'text',
          component: TextResults
        },
        {
          path: 'images',
          component: ImageResults
        },
        {
          path: 'videos',
          component: VideoResults
        },
        {
          path: 'audios',
          component: AudioResultcs
        }
      ]
    },{
      path: '/personal_center/',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta: {
        requireAuth:true
      },
      children: [
        {
          path: '/',
          component: MyEvidences
        },
        {
          path: 'my_evidences',
          component: MyEvidences
        },
        {
          path: 'account_info',
          component: AccountInfo
        },
        {
          path: 'account_balance',
          component: AccountBalance
        },
        {
          path: 'account_balance/online_payment',
          component: OnlinePayment
        },
        {
          path: 'trash',
          component: Trash
        }
      ]
    }
  ]
});

//拦截所有前端请求，对进入personal_center和其它需要认证的页面请求做状态判断
router.beforeEach((to, from, next) => {

  store.state.isLoading = false;
  if (to.matched.some(record => {return record.meta.requireAuth;}) || authPath.some(path=>{return to.path.indexOf(path)>=0})) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('enter auth');
    let user = null;
    let info = JSON.parse(localStorage.getItem('IP360'));
    // console.log('info: ', info);
    if(info){
      user = info.user;
    }
    if(!user || !user.token || (!user.timestamp || (Date.now() - user.timestamp > 1800*1000))){
      store.commit('logout');
      localStorage.removeItem('IP360');
      next({
        path: '/',
        query: {
          redirect: to.fullPath,
          action: 'login'
        }
      })
    } else {
      user.timestamp = Date.now();
      localStorage.setItem('IP360', JSON.stringify(info));
      store.commit('updateUser', user);
      next()
    }
  }else {
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js